import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import PageTitle from 'shared_components/page_title';
import PathologistSearchTable from './search_table';
const moduleTitle = 'PATHOLOGISTS';

const Pathologists = () => {
    return (
        <div>
            <Row justify="center" style={{ marginTop: 30 }}>
                <Col>
                    <PageTitle pageTitle={moduleTitle} />
                </Col>
            </Row>
            <PathologistSearchTable />
        </div>
    );
};

export default Pathologists;